module.exports = __webpack_public_path__ + "img/apple-touch-icon-120x120.b73211c2.png";